<div class="modal-header">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <h3 class="modal-title">Create A New Morphbox Property</h3>
</div>
<div>
  <div class="modal-body clearfix">
    <div class="col-lg-12">
      <div class="form-group mb-3">
        <label class="form-label" for="property_name">Property Name:</label>
        <input
          type="text"
          class="form-control"
          id="property_name"
          name="property-name"
          [(ngModel)]="row.text"
          maxlength="{{ inputLengths.MORPHBOX_ROW }}" />
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button [disabled]="loading" (click)="close()" class="btn btn-primary">
    Save Property
  </button>
  <button (click)="dismiss()" class="btn btn-danger">Cancel</button>
</div>
